import {
  GET_ALL_KEYPAIRS,
  CREATE_KEYPAIR,
  DELETE_KEYPAIR,
} from "../actions/keyPairsActions";

const initialState = {
  keyPairs: [],
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_KEYPAIRS:
      return { ...state, keyPairs: payload.keyPairs };

    case CREATE_KEYPAIR:
      return { ...state };

    case DELETE_KEYPAIR:
      return { ...state };

    default:
      return state;
  }
}
